import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-invalid-download',
  templateUrl: './invalid-download.component.html',
  styleUrls: ['./invalid-download.component.scss']
})
export class InvalidDownloadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
